<template>
  <div class="menu-page-bd bd">
    <div class="menu-wrap">
      <!-- 菜单管理 -->
      <div class="menu-content">
        <div class="search-hd">
          <el-form :inline="true">
            <el-form-item>
              <el-button v-if="funcView.menu_add" type="primary" icon="el-icon-plus" @click="addMenu()">{{ $t('Common.com_add') }}</el-button>
            </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <custom-select
                v-model="appId"
                url="AppMenu"
                :isDefault="true"
                :clearable="false"
                :props="{ label: 'appName', value: 'appId' }"
                :placeholder="$t('Common.com_please_select')"
                width="200px"
                :dataFilter="dataFilter"
                @init="handleNodeClick"
                @change="handleNodeClick"
              ></custom-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            v-if="funcView.menu_list"
            index
            type="radio"
            row-key="menuId"
            tableCode="systemMenu"
            v-model="selectedRow"
            :data="menuTree"
            @column="setColumn"
            @filter="filterChange"
            @sort="sortChange"
            height="100%"
          >
            <el-table-column :label="$t('Common.com_handle')" fixed="right" width="180">
              <template slot-scope="scope">
                <el-button @click="editMenu(scope.row)" type="text" size="mini" v-if="funcView.menu_edit">{{ $t('Common.com_edit') }}</el-button>
                <el-button v-if="scope.row.state === 1 && funcView.menu_forbid" @click="disableMenu(scope.row)" type="text" size="mini">
                  {{ $t('Common.com_disable') }}
                </el-button>
                <el-button v-if="scope.row.state !== 1 && funcView.menu_open" @click="disableMenu(scope.row)" type="text" size="mini">
                  {{ $t('Common.com_enable') }}
                </el-button>
                <el-button @click="deleteMenu(scope.row)" type="text" size="mini" v-if="funcView.menu_delete && !scope.row.state">{{ $t('Common.com_delete') }}</el-button>
              </template>
            </el-table-column>
          </custom-table>
        </div>
      </div>
      <div style="width: 16px; background-color: #e4ebf2"></div>
      <!-- 菜单功能管理 -->
      <menu-func v-if="funcView.menu_list_fun" :appId="appId" :functionView="funcView" :selectedRow="selectedRow" class="fun-content"></menu-func>
    </div>
    <!-- </div> -->
    <!-- 菜单新增编辑 -->
    <menu-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getMenuTree"></menu-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import menuItemDialog from './children/menu_item_dialog';
import menuFunc from './children/menu_func';

export default {
  name: 'menu',
  components: { menuItemDialog, menuFunc },
  data() {
    return {
      selectedRow: {},
      dialogVisible: false,
      dialogModel: {},
      appId: '',
      menuTree: [],
      formSearch: {
        search: '',
      },
    };
  },
  mounted() {
    this.getFuncView();

  },
  methods: {
    // 应用平台(过滤)
    dataFilter: function (list) {
      return list.filter((t) => t.appCode !== 'isynergy_cloud');
    },
    // 切换应用
    handleNodeClick: function () {
      this.getMenuTree();
      this.selectedRow = {};
    },
    // 获取菜单树
    getMenuTree: function () {
      this.$getJSON(apis.MenuTree, {
        appId: this.appId,
        ...this.formSearch,
      }).then((res) => {
        this.menuTree = res.data;
      });
    },
    // 新增菜单
    addMenu: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_menu.xzxtcd');
      this.dialogModel.data = {};
      this.dialogModel.data.appId = this.appId;
      this.dialogVisible = true;
    },
    // 编辑菜单
    editMenu: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_menu.bjxtcd');
      this.dialogModel.data = {};
      this.dialogModel.data.item = data;
      this.dialogVisible = true;
    },
    // 菜单禁用
    disableMenu: function (row) {
      this.$showConfirm(this.$t('base_menu.nqdyjyxzdcdm'))
        .then(() => {
          this.$postJSON(apis.MenuState, {
            menuId: row.menuId,
            state: row.state ? 0 : 1,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_edit_success'),
              type: 'success',
            });
            this.getMenuTree();
          });
        })
        .catch(() => {});
    },
    // 删除菜单
    deleteMenu: function (data) {
      const tips = this.$t('base_menu.nqdyscxzdcdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.MenuDelete}/${data.menuId}`).then(() => {
            this.expandedKeys = [data.parentId];
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getMenuTree();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.menu-page-bd {
  height: 100%;
  position: relative;
  padding: 16px;

  .menu-wrap {
    display: flex;
    height: 100%;
    .menu-content {
      display: flex;
      flex-direction: column;
      flex: 5;
      padding: 0 16px;
      background-color: #ffffff;
      overflow: hidden;
    }
    .fun-content {
      display: flex;
      flex-direction: column;
      flex: 3;
      padding: 0 16px;
      background-color: #ffffff;
      overflow: hidden;
    }
  }
}
</style>
